import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", { href: "https://docs.npmjs.com/about-npm" }, "NPM", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" is the recommended installation method when building large scale applications with Vue. It pairs nicely with module bundlers such as Webpack or Browserify. Vue also provides accompanying tools for authoring Single File Components. ")
const _hoisted_5 = { class: "py-10" }
const _hoisted_6 = {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Quick Start ")
const _hoisted_8 = { class: "py-5" }
const _hoisted_9 = { class: "pt-0" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Start a command prompt window or terminal and change directory to ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_12 = { class: "pb-5" }
const _hoisted_13 = /*#__PURE__*/_createVNode("li", { class: "pt-0" }, [
  /*#__PURE__*/_createTextVNode(" Install the Vue local project dependencies by executing "),
  /*#__PURE__*/_createVNode("code", null, "npm install"),
  /*#__PURE__*/_createTextVNode(" command. This command will install the dependencies in the local "),
  /*#__PURE__*/_createVNode("code", null, "node_modules"),
  /*#__PURE__*/_createTextVNode(" folder. By default, "),
  /*#__PURE__*/_createVNode("code", null, "npm install"),
  /*#__PURE__*/_createTextVNode(" will install all modules listed as dependencies in "),
  /*#__PURE__*/_createVNode("code", null, "package.json"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_14 = { class: "pb-5" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`npm install`))
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "pb-5" }, [
  /*#__PURE__*/_createTextVNode(" Execute "),
  /*#__PURE__*/_createVNode("code", null, "npm run serve"),
  /*#__PURE__*/_createTextVNode(" command to launch the server, watches your files, and rebuilds the app as you make changes to those files. Open your browser on "),
  /*#__PURE__*/_createVNode("a", { href: "http://localhost:8080/" }, "http://localhost:8080/"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_17 = { class: "pb-5" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`npm run serve`))
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "pb-5" }, " This command will take some time to finsh. Please wait for it to complete. ", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "pb-5" }, [
  /*#__PURE__*/_createTextVNode(" For more detailed information to install the Vue application, visit this official Vue "),
  /*#__PURE__*/_createVNode("a", { href: "https://v3.vuejs.org/guide/installation.html#installation" }, "documentation website"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Notice = _resolveComponent("Notice")
  const _component_router_link = _resolveComponent("router-link")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Notice, null, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_5, [
        _createVNode("h1", _hoisted_6, [
          _createVNode(_component_router_link, { to: "/build#quick_start" }),
          _hoisted_7
        ]),
        _createVNode("ol", _hoisted_8, [
          _createVNode("li", _hoisted_9, [
            _hoisted_10,
            _createVNode("code", null, "[unpacked path]/themes/" + _toDisplayString(_ctx.themeName.toLowerCase()) + "/vue/", 1),
            _hoisted_11
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_CodeHighlighter, { lang: "bash" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(`cd themes/` + _ctx.themeName.toLowerCase() + `/vue`), 1)
              ]),
              _: 1
            })
          ]),
          _hoisted_13,
          _createVNode("div", _hoisted_14, [
            _createVNode(_component_CodeHighlighter, { lang: "bash" }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ]),
          _hoisted_16,
          _createVNode("div", _hoisted_17, [
            _createVNode(_component_CodeHighlighter, { lang: "bash" }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            })
          ]),
          _hoisted_19
        ]),
        _hoisted_20
      ])
    ])
  ]))
}